import { CheckCircleIcon, XMarkIcon } from "@heroicons/react/20/solid";

interface AlertProps {
  message: string;
  style: string | "danger" | "success";
}

export default function Alert({ message, style }: AlertProps) {
  return (
    <div
      className={`rounded-md ${
        style === "danger" ? "bg-red-50" : "bg-green-50"
      } p-4`}
    >
      <div className="flex">
        <div className="flex-shrink-0">
          {style === "danger" ? (
            <>
              <XMarkIcon
                className={`h-5 w-5 text-red-400`}
                aria-hidden="true"
              />
            </>
          ) : (
            <>
              <CheckCircleIcon
                className={`h-5 w-5 text-green-400`}
                aria-hidden="true"
              />
            </>
          )}
        </div>
        <div className="ml-3">
          <p
            className={`text-sm font-medium ${
              style === "danger" ? "text-red-700" : "text-primary"
            }`}
          >
            {message}
          </p>
        </div>
        <div className="ml-auto pl-3">
          <div className="-mx-1.5 -my-1.5"></div>
        </div>
      </div>
    </div>
  );
}
